import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useNavigate} from 'react-router'

import {handleError} from '../../shared/helpers/errorHandling'
import {useAxios} from '../../shared/hooks/useApi'
import {TimeRange} from '../../shared/types'
import {Comment} from '../types'

export const QueryKey = 'comments'

type CommentsPayload = {
  timeRange: TimeRange
  locationId: string
}

export const useComments = (
  {timeRange, locationId}: CommentsPayload,
  options?: Omit<UseQueryOptions<Comment[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const axiosInstance = useAxios()
  const navigate = useNavigate()

  return useQuery<Comment[], AxiosError>({
    queryKey: [QueryKey, timeRange, locationId],
    queryFn: async ({signal}) => {
      try {
        const url = `/kpi/dashboard/comments/${locationId}`
        const response = await axiosInstance.get<Comment[]>(url, {
          params: {from: timeRange.startDate, to: timeRange.endDate},
          signal
        })

        return response.data
      } catch (err) {
        handleError(err as AxiosError, navigate)
        throw err
      }
    },
    staleTime: Infinity,
    ...options
  })
}
